import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface SuccessToast {
  id: number;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private _successToastsSubject = new BehaviorSubject<SuccessToast[]>([]);
  private successToastSeq = 0;
  get successToasts$(): Observable<SuccessToast[]> { return this._successToastsSubject.asObservable(); }

  showAlertMessage = false;
  alertMessage = "";
  alertType: "success" | "danger" | "warning" | "info" = "success";
  alertIcon = "";
  show(message: string, type: 'success' | 'danger' | 'warning' | 'info' = 'info') {
    const toastId = 'toast-' + Date.now();

    const toastHtml = `
      <div id="${toastId}" class="toast align-items-center text-bg-${type} border-0 show" 
           role="alert" aria-live="assertive" aria-atomic="true"
           style="min-width: 260px; margin-bottom: 10px;">
        <div class="d-flex">
          <div class="toast-body">${message}</div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" 
                  data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      </div>
    `;

    let container = document.getElementById('toast-container');

    // Create container once
    if (!container) {
      container = document.createElement('div');
      container.id = 'toast-container';
      container.style.position = 'fixed';
      container.style.top = '20px';
      container.style.right = '20px';
      container.style.zIndex = '9999';
      document.body.appendChild(container);
    }

    container.insertAdjacentHTML('beforeend', toastHtml);

    // Auto remove after 4 sec
    setTimeout(() => {
      const toastEl = document.getElementById(toastId);
      if (toastEl) toastEl.remove();
    }, 4000);
  }
  /** Light-green success alert. Social Monitoring only: rendered by `app-alert-toast`, mounted in StreamAnalyticsComponent. */
  showSuccess(message: string) {
    const toast: SuccessToast = { id: ++this.successToastSeq, message };
    this._successToastsSubject.next([...this._successToastsSubject.value, toast]);

    // Auto remove after 4 sec, same as show()
    setTimeout(() => this.dismissSuccess(toast.id), 4000);
  }
  dismissSuccess(id: number) {
    this._successToastsSubject.next(this._successToastsSubject.value.filter(t => t.id !== id));
  }
    showToaster(message: string, type: "success" | "error" | "info" = "info") {
    let alertType: "success" | "danger" | "info" | "warning";

    switch (type) {
      case "error":
        alertType = "danger";
        break;
      case "success":
        alertType = "success";
        break;
      case "info":
      default:
        alertType = "info";
        break;
    }

    this.showAlert(message, alertType);
  }
 showAlert(
    message: string,
    type: "success" | "danger" | "info" | "warning" = "success"
  ) {
    this.alertMessage = message;
    this.alertType = type;
    this.alertIcon = this.getAlertIcon(type);
    this.showAlertMessage = true;

    // Auto-hide alert after 5 seconds
    setTimeout(() => {
      this.hideAlert();
    }, 5000);
  }
    hideAlert() {
    this.showAlertMessage = false;
  }
    private getAlertIcon(type: string): string {
    const iconMap: { [key: string]: string } = {
      success: "/assets/outreach-sidemenu-icon/Alert-success-icon.svg",
      danger: "/assets/outreach-sidemenu-icon/Alert-danger-icon.svg",
      warning: "/assets/outreach-sidemenu-icon/Alert-success-icon.svg", // Using success icon as fallback
      info: "/assets/outreach-sidemenu-icon/Alert-success-icon.svg", // Using success icon as fallback
    };
    return iconMap[type] || iconMap.success;
  }

}
